import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CounsellingRoutingModule } from './counselling-routing.module';
import { CounsellingLandingpageComponent } from './counselling-landingpage/counselling-landingpage.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { CounsellingLinksComponent } from './counselling-links/counselling-links.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// import { ExcelService } from 'src/app/excel.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { AppComponent } from 'src/app/app.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { StudentCounsellingComponent } from './student-counselling/student-counselling.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';




export const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD MMMM YYYY',

  },
};

@NgModule({
  declarations: [
    CounsellingLandingpageComponent,
    CounsellingLinksComponent,
    StudentCounsellingComponent,


  ],
  imports: [
    CommonModule,
    CounsellingRoutingModule,
    AcademicFormModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],

  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }, NgDialogAnimationService],
  bootstrap: [AppComponent]
})

export class CounsellingModule { }
